export default __webpack_public_path__ + "static/142-min-min-43c43632fb1783dd52493d4dd4cdc00c.jpg";